module.exports = __webpack_public_path__ + "21_vis1.jpg?4ee391edb9ea115a8c4d56cfa9dee88d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/21_vis1.jpg
// module id = 180
// module chunks = 0